import type { FaireProductEntity } from "../../entity_types/product";

export const p_2vhmffepct: FaireProductEntity = {
  token: "p_2vhmffepct",
  type: "product",
  name: "ALO Comfort",
  brandToken: "b_7h76tk1dcp",
  brandName: "ALO drink",
  imageUrl:
    "https://cdn.faire.com/fastly/91ebd8b13d2de1736ef51ea6dfe4b9374e5db5568fb4e996c3ab68602c1a3ef8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cf9a42786734f040bc2d22c8411ecce6a1563952af3f96581fe2bf103e1caab.png",
  ],
  priceDollars: 2.05,
  description:
    "12 pack of 500ml bottles\n\nALO Comfort\n\nIT’S JUST PEACHY TO DRINK WATERMELON\n The comforting combo of watermelon and peach will make you smile all day. It’s a bright flavor combination that satisfies as it refreshes.\n\n * Sweetened with cane sugar \n * Aloin-Free \n * No Artificial Flavors, Preservatives or Colors \n * Real aloe vera juice & pulp – never from powder \n * \n * \n * \n * ",
  tags: [],
  msrpDollars: 4.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:31.043Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
